const SEARCH_RADIUS_OPTIONS = [5, 10, 15];

export default function PatientAppointmentSearchRadius({ value, onChange, disabled }) {
    return (
        <>
            <div className="text-sm font-semibold text-gray-500 mb-2">Search Radius</div>
            <select
                aria-label="Search radius in miles"
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-800 focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:cursor-not-allowed disabled:bg-gray-100"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                disabled={disabled}
            >
                <option value="" disabled>Select miles</option>
                {SEARCH_RADIUS_OPTIONS.map((radius) => (
                    <option key={radius} value={radius}>{radius} miles</option>
                ))}
            </select>
        </>
    );
}
